export default {
	scrollToTop() {
		$("html, body").animate({
			scrollTop: 0,
		});
		$(".Quiz").animate(
			{
				scrollTop: 0,
			},
			100,
		);
	},

	loadAndDisplayQuiz(quizParams) {
		const quizUrl = quizParams.name
			? `/quizzes/N_A/?name=${encodeURIComponent(quizParams.name)}`
			: `/quizzes/${quizParams.id}`;
		let callback;
		// If the Quiz is being shown in a normal module (like in elternquiz): Reload the content of that module
		if ($(".Quiz").length && !$(".Quiz").closest("#quiz-modal").length) {
			callback = (data) => {
				$(".Quiz").parent().html(data);
			};
		} else {
			callback = (data) => {
				$("#quiz-modal .modal-body").html(data);
				$("#quiz-modal").modal("show");
				$(document).one("page:change", function () {
					setTimeout(pp.quiz.indicateScrollable, 500);
				});
				$(document).trigger("page:change");
			};
		}
		$.get(quizUrl, callback, "html");
	},

	indicateScrollable: () => {
		$(".Quiz").off("scroll").on("scroll", pp.quiz.manageScrollIndicator);
		$(".Quiz").trigger("scroll");
	},

	openNextStep: (nextStepUrl) => {
		// Catch the case where this is called for moderators via the Quiz' PrivatePub channel
		if ($("body").hasClass("moderator-view")) {
			return;
		}
		$.post(nextStepUrl);
		$(document).one("page:change", function () {
			setTimeout(pp.quiz.indicateScrollable, 500);
		});
	},

	manageScrollIndicator: () => {
		const $quizElement = $(".Quiz");
		const $scrollIndicator = $(".ScrollableIndicator");
		const scrollableIndicatorHtml =
			'<div class="ScrollableIndicator"><span class="glyphicon glyphicon-arrow-down"></span></div>';

		// Check if $quizElement is scrollable
		const isScrollable =
			$quizElement.prop("scrollHeight") > $quizElement.prop("clientHeight");
		const scrolledToBottom =
			// @ts-expect-error
			$quizElement.scrollTop() + $quizElement.innerHeight() >=
			// @ts-expect-error
			$quizElement[0].scrollHeight - 20;

		// pp.log("manageScrollIndicator", $quizElement, $quizElement.prop('scrollHeight'), $quizElement.prop('clientHeight'));
		if (isScrollable && !scrolledToBottom) {
			// If the user has NOT scrolled to the bottom and there is no ScrollableIndicator div, insert one
			if (!$scrollIndicator.length) {
				$(".Quiz").append(scrollableIndicatorHtml);
			}
		} else {
			// If the $quizElement is not scrollable or the user has scrolled to the bottom, and there is a ScrollableIndicator div, remove it
			if ($scrollIndicator.length) {
				$scrollIndicator.remove();
			}
		}
	},

	initQuizQuestion: () => {
		pp.quiz.indicateScrollable();
		pp.quiz.scrollToTop();

		const handleOptionClick = (event) => {
			const answerId = $(event.currentTarget).attr("data-answer-option-id");
			const $checkbox = $("#selected-answers-form").find(
				`input[name='quizzes[selected_answer_ids][]'][value='${answerId}']`,
			);

			$(".AnswerOption").removeClass("AnswerOption--selected");

			$(event.currentTarget)
				.parents(".SelectableAnswerOptions")
				.addClass("SelectableAnswerOptions--with-selection"); // Only used in elternquiz
			$checkbox.prop("checked", true);
			$checkbox.siblings().prop("checked", false);

			$(event.currentTarget).addClass("AnswerOption--selected");
			$(".j-submit-answer")
				// @ts-expect-error
				.val($(".j-submit-answer").attr("data-submit-answer-text"))
				.prop("disabled", false);
		};

		pp.comment.initFormHandlerListeners(
			$("div.Question__comments-form"),
			".ScoreComment__add-fields--first",
		);
		$(".Question__answer-options .AnswerOption").on("click", handleOptionClick);
		$(".j-submit-answer").on("click", (event) => {
			event.preventDefault();
			if ($(event.currentTarget).prop("disabled")) {
				return false;
			}
			$(event.currentTarget).prop("disabled", true);
			$(event.currentTarget).parents("form").submit();
			$(event.currentTarget).parents("form").find(".AnswerOption").off("click"); // Don't allow changing (and re-submitting an AnswerOption)
		});
	},

	initQuestionClarification() {
		pp.quiz.scrollToTop();
		const withClarification = $(".QuestionClarification").length;
		if (withClarification) {
			$(document).one("click", ".j-toggle-QuestionClarification", () => {
				pp.quiz.scrollToTop();
				$(".AnswersResult, .QuestionClarification").toggleClass("hidden");
			});
		}
	},

	setScoreCommentsPosition($questionEl) {
		if (!$questionEl.children(".ScoreCommentsSection").length) {
			return;
		}
		pp.log("Setting scoreComments position", $questionEl);
		$(".ProjectorWrapper .QuizResultsContainer").css({
			display: "block", // NB this is so the projector can be scrolled.
		});
	},

	showQuestionResult($container, index) {
		const $allResults = $container.find("[data-question-id]");
		$allResults.removeClass("animated fadeIn").addClass("hidden");
		const $nextQuestion = $allResults.eq(index);
		pp.quiz.setScoreCommentsPosition($nextQuestion);
		$nextQuestion.removeClass("hidden").addClass("animated fadeIn");
	},

	initResultsCarousel(quizId) {
		let visibleResult = 0;
		const $resultsContainer = $(`.QuizResults[data-quiz-id="${quizId}"]`);
		pp.quiz.setScoreCommentsPosition(
			$resultsContainer.find(".QuestionResult").first(),
		);
		$resultsContainer
			.find(".QuizResults__QuestionNav .QuizActions__item")
			.on("click", (e) => {
				const $container = $(e.target).parents(".QuizResults");
				const $questionResults = $container.find("[data-question-id]");
				if ($(e.currentTarget).hasClass("QuizActions__next-question")) {
					visibleResult += 1;
				} else {
					visibleResult -= 1;
				}
				if (visibleResult > $questionResults.length - 1) {
					visibleResult = 0;
				}
				if (visibleResult < 0) {
					visibleResult = $questionResults.length - 1;
				}
				pp.quiz.showQuestionResult($container, visibleResult);
			});
	},

	updateUnlockableCounts(unlockerUnlockableJoins) {
		$.each(unlockerUnlockableJoins, (idx, uuj) => {
			const $countEl = $(`#j-unlockable-count-for_${uuj.unlockable.id}`);
			let nextCount = parseInt($countEl.text(), 10) + 1;
			$countEl.text(nextCount);
		});
	},

	handleQuestionInModAccordion(questionEl) {
		const $questionEl = $(questionEl);

		// pp.log("into handleQuestionInModAccordion", $questionEl, $questionEl.data());
		let correctAnswers = 0;
		let incorrectAnswers = 0;

		$questionEl.data("correctAnswerOptionsIds").forEach((answerOptionId) => {
			if (
				$questionEl.data("answerAttemptsPerOption")[answerOptionId] ===
				undefined
			) {
				return;
			}
			// Parse back to int after being stringified in `vueBusHandler`
			correctAnswers += parseInt(
				$questionEl.data("answerAttemptsPerOption")[answerOptionId],
			);
		});
		$questionEl.data("incorrectAnswerOptionsIds").forEach((answerOptionId) => {
			if (
				$questionEl.data("answerAttemptsPerOption")[answerOptionId] ===
				undefined
			) {
				return;
			}
			// Parse back to int after being stringified in `vueBusHandler`
			incorrectAnswers += parseInt(
				$questionEl.data("answerAttemptsPerOption")[answerOptionId],
				10,
			);
		});
		// NB the `find` functions need to be chained, otherwise the MutationObserver gets triggered just by looking up a DOM element  ㄟ( ▔, ▔ )ㄏ
		$questionEl
			.find(".AnswerOption--correct-text-only")
			.find(".RecordIndex__item__stacked-number")
			.text(correctAnswers);
		$questionEl
			.find(".AnswerOption--incorrect-text-only")
			.find(".RecordIndex__item__stacked-number")
			.text(incorrectAnswers);
		const totalAnswersCount = Object.values(
			$questionEl.data("answerAttemptsPerOption"),
		).reduce((a, b) => parseInt(a, 10) + parseInt(b, 10), 0);
		$questionEl.find(".j-answer-attempts-size").text(totalAnswersCount);
	},

	observeQuestionInModAccordion($questionEl) {
		const observer = new MutationObserver((mutations) => {
			mutations.forEach(({ type, target }) => {
				if (type == "attributes") {
					pp.quiz.handleQuestionInModAccordion(target);
				}
			});
		});
		observer.observe($questionEl[0], { attributes: true });

		let vueBusHandler;
		let vueBusEvent;
		if ($questionEl.find(".QuestionResult--commentable").length) {
			vueBusEvent = "question_comment-CREATE";
			vueBusHandler = (commentable) => {
				if (commentable.id == $questionEl.data("questionId")) {
					// NB the `commentable.id` is ofc not really an AnswerOption's id but it will still serve to count up the `totalAnswersCount`
					pp.quiz.incrementAnswerAttemptPerOption($questionEl, commentable.id);
				}
			};
		} else {
			vueBusEvent = "answer_attempt-CREATE";
			vueBusHandler = (answerAttempt) => {
				if (
					answerAttempt.answer_option.question_id ==
					$questionEl.data("questionId")
				) {
					pp.quiz.incrementAnswerAttemptPerOption(
						$questionEl,
						answerAttempt.answer_option_id,
					);
				}
			};
		}
		pp.vue.bus.$on(vueBusEvent, vueBusHandler);
		$questionEl.one("destroyed destroyed_proxy", () => {
			pp.vue.bus.$off(vueBusEvent, vueBusHandler);
		});
	},

	incrementAnswerAttemptPerOption($questionEl, answerOptionId) {
		const answerAttemptsPerOption = $questionEl.data("answerAttemptsPerOption");
		if (answerAttemptsPerOption[answerOptionId] === undefined) {
			answerAttemptsPerOption[answerOptionId] = 0;
		}
		answerAttemptsPerOption[answerOptionId] += 1;
		$questionEl.attr(
			"data-answer-attempts-per-option",
			JSON.stringify(answerAttemptsPerOption),
		);
	},

	openQuestionPanel(questionId) {
		const $questionPanel = $(`div.panel[data-question-id='${questionId}']`);
		pp.log("MOD TASKS triggerTaskPanelLink", $questionPanel);
		$questionPanel.find("[data-toggle='collapse']").trigger("click");
		setTimeout(() => {
			// Wait until panel is open
			pp.viewHelpers.scrollToElement($questionPanel);
		}, 500);
	},
};
